import { zodResolver } from '@hookform/resolvers/zod';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useCloneAgent } from 'apis/business/agent/hook';
import { AgentCloneRequest } from 'apis/business/agent/types';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import { agentCloneSchema } from 'utils/schema/validator/AgentCloneValidation';

export default function BuildScratchForm() {
  const { mutateAsync: cloneAgent, isPending } = useCloneAgent();
  const { control, handleSubmit } = useForm<AgentCloneRequest>({
    resolver: zodResolver(agentCloneSchema)
  });

  const handleCloneAgent = async (data: AgentCloneRequest) => {
    cloneAgent({ ...data });
    localStorage.setItem('configuringAgent', 'withoutWebUrl');
  };

  return (
    <Box component='form' bgcolor='white' p={3} borderRadius={2}>
      <Typography variant='h3' mb={0.5} fontSize={16} fontWeight={600}>
        Build from Scratch
      </Typography>
      <Typography variant='body2' mb={2} fontSize={14} color='secondary'>
        Start creating your custom agent with full control over all settings.
      </Typography>
      <Grid container spacing={1} mb={3}>
        <Grid size={12}>
          <Typography mb={1} fontSize={14} fontWeight={400}>
            Agent Name
          </Typography>
          <Input name='name' size='small' control={control} fullWidth required />
          <Typography color='secondary' mb={1} fontWeight={400} fontSize={12}>
            What name will your assistant go by
          </Typography>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '40px'
        }}
      >
        <Button
          variant='contained'
          color='primary'
          type='submit'
          isPending={isPending}
          onClick={handleSubmit(handleCloneAgent)}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
}
